/** URL prefix for the test copy of the site on the same domain (e.g. /test/buchen). */
export const TEST_PATH_PREFIX = "/test";

const isTestPath = (pathname) => {
  const p = String(pathname || "");
  return p === TEST_PATH_PREFIX || p.startsWith(`${TEST_PATH_PREFIX}/`);
};

/** React Router basename — only `/test` when the user is under that path. */
export const getRouterBasename = () => {
  if (typeof window !== "undefined" && isTestPath(window.location.pathname)) {
    return TEST_PATH_PREFIX;
  }
  return "";
};

/** `production` | `test` — must match server `resolveDeploymentScope`. */
export const getDeploymentScope = () => {
  if (typeof window !== "undefined" && isTestPath(window.location.pathname)) {
    return "test";
  }

  const fromEnv = String(process.env.REACT_APP_DEPLOYMENT_SCOPE || "")
    .trim()
    .toLowerCase();
  if (fromEnv === "test") return "test";

  return "production";
};

export const isTestDeployment = () => getDeploymentScope() === "test";

/** Query params for all `/admin/*` requests. */
export const adminScopeParams = (extra = {}) => ({
  ...extra,
  adminScope: getDeploymentScope(),
});
